import { api } from './api/axiosInstance';
import { SETTINGS } from './api/endpoints';

export const SettingsService = {
  getGeneralSettings: () => api.get(SETTINGS.GENERAL),
  updateGeneralSettings: (data) => api.put(SETTINGS.GENERAL, data),
  sendLowStockTestEmail: (data) => api.post(SETTINGS.TEST_LOW_STOCK_EMAIL, data),
  getCenterNotificationEmails: () => api.get(SETTINGS.CENTER_NOTIFICATION_EMAILS),
  updateCenterNotificationEmails: (centerId, data) => api.put(SETTINGS.UPDATE_CENTER_NOTIFICATION_EMAILS(centerId), data),
  // Dynamic app settings CRUD
  getAppSettings: () => api.get(SETTINGS.APP_SETTINGS),
  createAppSetting: (data) => api.post(SETTINGS.APP_SETTINGS, data),
  updateAppSetting: (key, data) => api.put(SETTINGS.APP_SETTING(key), data),
  deleteAppSetting: (key) => api.delete(SETTINGS.APP_SETTING(key)),
};

export default SettingsService;
